<div class="modal-header">
  <h4 class="modal-title faqGroupModal__title">
    @if (faqGroup) {
      Editar grupo
    }

    @if (!faqGroup) {
      Nuevo grupo de preguntas
    }
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Cerrar"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body faqGroupModal">
  @if (!loading) {
    <form
      id="formFaqGroup"
      [formGroup]="formFaqGroup"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid px-0">
        <div class="row">

          <!-- Datos derivados: van como texto de solo lectura FUERA de los
               inputs, nunca precargados dentro de un campo editable. -->
          @if (faqGroup) {
            <div class="col-12 mb-4">
              <div class="faqGroupModal__meta">

                <p class="faqGroupModal__metaRow d-flex mb-1">
                  <span class="faqGroupModal__metaLabel">ID</span>
                  <span class="faqGroupModal__metaValue text-truncate">
                    {{ faqGroup.faqGroupId }}
                  </span>
                </p>

                <p class="faqGroupModal__metaRow d-flex mb-1">
                  <span class="faqGroupModal__metaLabel">Preguntas</span>
                  <span class="faqGroupModal__metaValue text-truncate">
                    {{ faqGroup.faqs.length }}
                  </span>
                </p>

                <p class="faqGroupModal__metaRow d-flex mb-0">
                  <span class="faqGroupModal__metaLabel">Actualizado</span>
                  <span class="faqGroupModal__metaValue text-truncate">
                    {{ faqGroup.updatedAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                  </span>
                </p>

              </div>
            </div>
          }

          <!-- ---------------------------------------------------------------- -->
          <!--                          ANCHOR TITLE                            -->
          <!-- ---------------------------------------------------------------- -->
          <div class="col-12 form-group mb-4">
            <label htmlFor="faqGroupTitle" class="form-label">
              {{ dataForm['title'].label }}
            </label>
            <input
              id="faqGroupTitle"
              type="text"
              class="form-control"
              formControlName="title"
              [placeholder]="dataForm['title'].placeholder ?? dataForm['title'].label"
              [attr.aria-invalid]="submitted && f['title'].errors ? 'true' : null"
              [attr.aria-describedby]="submitted && f['title'].errors ? 'faqGroupTitleError' : 'faqGroupTitleHelp'"
              [ngClass]="{
                'is-invalid': submitted && f['title'].errors
              }">

            <!-- Contador derivado: fuera del input, como texto de apoyo. -->
            <div class="d-flex justify-content-between gap-2 mt-1">
              <span id="faqGroupTitleHelp" class="faqGroupModal__help">
                Se muestra como encabezado de sección en la pantalla de Ayuda.
              </span>
              <span
                class="faqGroupModal__counter"
                [ngClass]="{
                  'faqGroupModal__counter--over': (f['title'].value?.length ?? 0) > titleMaxLength
                }">
                {{ f['title'].value?.length ?? 0 }}/{{ titleMaxLength }}
              </span>
            </div>

            @if (submitted && f['title'].errors) {
              <div class="invalid-feedback d-block" id="faqGroupTitleError">
                @if (f['title'].errors!['required']) {
                  <div>{{ dataForm['title'].requiredMessage }}</div>
                }
                @if (f['title'].errors!['maxlength']) {
                  <div>El título no puede tener más de {{ titleMaxLength }} caracteres.</div>
                }
              </div>
            }
          </div>

          <!-- ---------------------------------------------------------------- -->
          <!--                          ANCHOR STATUS                           -->
          <!-- ---------------------------------------------------------------- -->
          <div class="col-12 mb-2">
            <div class="faqGroupModal__switchRow d-flex align-items-center justify-content-between gap-3">

              <div class="faqGroupModal__switchText">
                <label htmlFor="faqGroupStatus" class="form-label mb-0">
                  {{ dataForm['status'].label }}
                </label>
                <p class="faqGroupModal__help mb-0">
                  @if (f['status'].value) {
                    Los residentes verán este grupo y sus preguntas activas.
                  } @else {
                    El grupo queda oculto en la app junto con todas sus preguntas.
                  }
                </p>
              </div>

              <p-inputSwitch
                inputId="faqGroupStatus"
                formControlName="status">
              </p-inputSwitch>

            </div>
          </div>

        </div>
      </div>
    </form>
  }
</div>

<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100 faqGroupModal__actionBtn">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <!-- Nunca deshabilitado: la validación se resuelve en onSubmit(). -->
    <button
      type="submit"
      form="formFaqGroup"
      class="btn btn-primary w-100 faqGroupModal__actionBtn">
      {{ faqGroup ? 'Actualizar' : 'Registrar' }}
    </button>
  </div>
</div>
